export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=705540a5c0d9931dd37bc82d67ecb258801666cede&name=getStoresServerAction!'